import gql from 'graphql-tag'

export const DELETE_PAGE = gql`
    mutation deletePage($pageID: ID!, $website: ID!) {
        deletePage(pageID: $pageID, website: $website) {
            statusCode
            success
        }
    }
`
